import { Route, Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { activeEventTab } from "../../store/reducers/eventSlice";

export const IsUserLoggedIn = () => {
  const login = useSelector((state) => {
    return state.user.loggedIn;
  });

  const loginStatus = () => {
    return login;
  };

  return loginStatus;
};

const ProtectedRoute = ({ component: Component, key: Key, ...rest }) => {
  const activeTab = useSelector((state) => {
    return state.event.activeTab;
  });
  const dispatch = useDispatch();
  const loginStatus = IsUserLoggedIn();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!loginStatus()) {
          return (
            <Redirect
              to={{
                pathname: "/",
                state: { from: props.location },
              }}
            />
          );
        }
        if (!rest.access) {
          return (
            <Redirect
              to={{
                pathname: "/",
                state: { from: props.location },
              }}
            />
          );
        }
        if (
          props?.location?.pathname === "/dashboard" &&
          activeTab === "packages"
        ) {
          dispatch(activeEventTab("mice"));
        }

        return <Component key={Key} link_type={rest.link_type} {...props} />;
      }}
    />
  );
};

export default ProtectedRoute;
